/* eslint-disable */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import { getCaseSettingData } from '@modules/appraisalAdmin/selectors/letterCaseSetting';

const TextInputWrapper = (props) => {
  const caseSetting = useSelector(getCaseSettingData);

  const isValidCaseInput = () => {
    const { select, type, disableCase } = props;

    return !select && type !== 'date' && type !== 'time' && type !== 'number' && !disableCase;
  }
  const onChangeHandler = e => {
    const { onChange } = props;
    if (isValidCaseInput() && caseSetting === 'All Uppercase' && e.target.value && e.target.selectionEnd) {
      const selectionEnd = e.target.selectionEnd;
      e.target.value = e.target.value.toUpperCase();
      e.target.selectionEnd = selectionEnd;
      onChange(e);
    }
    onChange(e);
  }
  return (
    <TextField
      {...props}
      onChange={onChangeHandler}
    />
  );
};

export default TextInputWrapper;
